import { Component } from '@angular/core';

@Component({
  selector: 'yard-report',
  templateUrl: './yard-report.component.html',
  styleUrls: ['./yard-report.component.css']
})
export class YardReportComponent {

}
